module.exports = __webpack_public_path__ + "media/images/emblems/Penthalaz-coat_of_arms-390c4563cf7ab9f0576e888490e780f7.svg";